export default "__VITE_ASSET__sCq_tz73__"